import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Es terapia psicológica?',
  answer: 'No. Es un sistema práctico de regulación nerviosa aplicado. No reemplaza la terapia, sino que te da herramientas corporales para gestionar la ansiedad en el momento.'
}, {
  question: '¿Sirve si llevo años con ansiedad?',
  answer: 'Sí. El sistema nervioso aprende por repetición, no por tiempo de diagnóstico. Estas herramientas están diseñadas para reentrenar tu respuesta de alerta, sin importar cuánto tiempo lleves así.'
}, {
  question: '¿Necesito hacerlo perfecto para ver resultados?',
  answer: 'No. Está diseñado para mujeres con poco tiempo disponible. La idea es aplicar pequeñas herramientas de regulación en tu día a día, no sumar una exigencia más.'
}, {
  question: '¿Reemplaza tratamiento médico?',
  answer: 'No. Es un complemento práctico de regulación emocional. Si estás bajo tratamiento médico o psiquiátrico, este sistema te ayudará a gestionar el día a día, pero no debes dejar tu tratamiento.'
}, {
  question: '¿Cómo accedo al contenido?',
  answer: 'Recibes acceso digital inmediato tras el pago. Todo el material llega a tu correo electrónico para que puedas descargarlo y empezarlo cuando quieras.'
}, {
  question: '¿Qué pasa si siento que esto no es para mí?',
  answer: 'Podés probar el sistema con tranquilidad. Si dentro del período de garantía sentís que no es para vos, podés solicitar un reembolso.'
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="space-y-4 max-w-3xl mx-auto" data-id="element-9">
      {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg bg-white overflow-hidden shadow-sm" data-id="element-10">
          <button className="w-full px-6 py-4 text-left flex items-center justify-between bg-white hover:bg-gray-50 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-11">
            <span className="font-bold text-gray-900 text-lg pr-4" data-id="element-12">
              {faq.question}
            </span>
            {openIndex === index ? <ChevronUp className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-13" /> : <ChevronDown className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-14" />}
          </button>

          {openIndex === index && <div className="px-6 pb-6 pt-2 text-gray-600 leading-relaxed border-t border-gray-100 bg-gray-50/50" data-id="element-15">
              {faq.answer}
            </div>}
        </div>)}
    </div>;
}